import B_TweenObject from '../../../../base/dev/animate/tween/B_TweenObject';

const init = () => {
    return class R_TweenObject extends B_TweenObject {
        constructor(canvas) {
            super(canvas);
        }

        move(obj, x, y, cb, spd) {
            this.tween(
                obj,
                '',
                {
                    arrStep: [
                        {
                            option: { x, y },
                            time: this.getCanvas().time / spd,
                            effect: 'none'
                        }
                    ]
                }, (tween) => {
                    if (cb) cb(tween);
                }
            );
        }
    };
};

export default init();



// WEBPACK FOOTER //
// ./src/assets/js/codmos/game/lcPlugIn/canvas/runner/dev/animate/tween/R_TweenObject.js